export type DeviceType = 'desktop' | 'mobile' | 'tablet';

/**
 * Classifies the current browser by form factor from its user agent,
 * matching how CrUX splits field data into mobile, tablet and desktop.
 */
const getDeviceType = (): DeviceType => {
  if (typeof navigator === 'undefined') return 'desktop';

  const { maxTouchPoints, userAgent } = navigator;

  // iPadOS reports a desktop Safari user agent, so touch support gives it away
  const isIpadOs = /Macintosh/i.test(userAgent) && maxTouchPoints > 1;

  if (isIpadOs || /iPad|Tablet|Android(?!.*Mobile)/i.test(userAgent)) {
    return 'tablet';
  }

  if (/Mobi|iPhone|iPod|Android/i.test(userAgent)) return 'mobile';

  return 'desktop';
};

export default getDeviceType;
